import { getAllOrderShowtimesInJourney, getOrderRelatedFilmById, getOrderRelatedShowtimeById } from '@vista/omnichannel-components-domain';
export function getDescriptionForJourney(journey, displayText, i18n) {
    const orderShowtimes = getAllOrderShowtimesInJourney(journey);
    if (orderShowtimes.length >= 1) {
        const firstShowtime = getOrderRelatedShowtimeById(orderShowtimes[0].showtimeId);
        if (!firstShowtime)
            throw new Error(`Cannot find showtime with ID: ${orderShowtimes[0].showtimeId}.`);
        const film = getOrderRelatedFilmById(firstShowtime.filmId);
        if (!film)
            throw new Error(`Cannot find film with ID: ${firstShowtime.filmId}.`);
        const filmTitle = i18n.translatable(film.title);
        if (orderShowtimes.length === 1) {
            return filmTitle;
        }
        else {
            return i18n.template(displayText.multiShowtimeJourneyTitleFormat, {
                firstFilmTitle: filmTitle,
                multiShowtimeJourneyTitleFormat: orderShowtimes.length - 1
            });
        }
    }
    return displayText.foodAndDrinkJourneyTitle;
}
